import { LoadableActivatable, ActivationTriggerType } from '@confluence/loadable';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess';

export const LoomCrossFlowPopupLoader = LoadableActivatable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LoomCrossFlowPopupComponent" */ './LoomCrossFlowPopupComponent'
			)
		).LoomCrossFlowPopupComponent,
	triggers: [
		{
			type: ActivationTriggerType.HOVER,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.LoomButton,
});

export const LoomCrossJoinPopupLoader = LoadableActivatable({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-LoomCrossJoinPopupComponent" */ './LoomCrossJoinPopupComponent'
			)
		).LoomCrossJoinPopupComponent,
	triggers: [
		{
			type: ActivationTriggerType.HOVER,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.LoomButton,
});
